import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import { axiosPost } from 'shared/api/axios'
import displayError from 'shared/utils/displayError'

const catchFunc = (err: AxiosError) => {
  const message = err?.response?.data?.message ?? 'An error has occurred'
  displayError({
    errorMessage: message,
  })
}

const uploadAdapter = (loader) => {
  return {
    upload: () => {
      return new Promise((resolve, reject) => {
        const body = new FormData()
        loader.file.then((file) => {
          body.append('file', file)
          axiosPost(
            apiUrls.pages + '/' + apiUrls.actionUpload,
            body,
            catchFunc,
            'multipart/form-data',
          )
            .then((res) => {
              if (res.data?.status !== true) {
                displayError({
                  errorMessage: res?.data?.message ?? 'An error occurred while uploading a file.',
                })
                reject(null)
              } else {
                resolve({ default: res.data?.url })
              }
            })
            .catch((err) => {
              reject(err)
            })
        })
      })
    },
  }
}

export default uploadAdapter
